"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCommentSection = void 0;
function buildCommentSection(section) {
    throw new Error(`Comments aren't supported yet. Cannot process ${section.type}`);
    // if ('headers' in section) {
    //   const subsections: Array<Array<string>> = [section.headers];
    //   for (let subsectionIndex = 0; subsectionIndex < section.headers.length; subsectionIndex++) {
    //     subsections
    //     for (const comment of section.comments[section.headers[subsectionIndex]]) {
    //       subsections[subsectionIndex].push(comment);
    //     }
    //   }
    // } else {
    // }
    // // Change it from an array of columns to an array of rows
    // const headers = section.comments.map((comment) => comment.header);
    // const rows: Array<Array<string>> = [];
    // for (let i = 0; i < section.comments.length; i++) {
    //   for (let j = 0; j < section.comments[i].content.length; j++) {
    //     if (!rows[j]) rows[j] = [];
    //     rows[j][i] = section.comments[i].content[j];
    //   }
    // }
    // return {
    //   type: 'comment',
    //   headers,
    //   rows,
    // };
}
exports.buildCommentSection = buildCommentSection;
/**
 
interface CommentSectionDefinitionArray extends SectionDefinitionBase {
  type: 'comment';
  comments: Array<Array<string>>;
}
interface CommentSectionDefinitionObject extends SectionDefinitionBase {
  type: 'comment';
  headers: Array<string>;
  comments: Record<string, string>;
}

/////////////
 interface CommentSectionSchema extends SectionSchemaBase {
  type: 'comment';
  subsections: Array<CommentSubsection>;
}

export type CommentSubsection = {
  comments: Array<string>;
}
 */
//# sourceMappingURL=commentSection.js.map